import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

//Layout
import MainLayout from "Layouts/Main";

// styles
import "./styles.scss";

//assets
import assets from "../../../../Assets";

// utils
import { validateInput } from "Services/Utils/validateInput";
//Custom Components
import InputBox from "Components/InputBox";
import Button from "Components/Button";
import DatePicker from "Components/Common/DatePicker";
import SuccessCard from "Components/Common/SuccessCard";
import ErrorMessage from "Components/ErrorMessage";

//redux
import { useDispatch } from "react-redux";
import {
  addOfferCodes,
  editOfferCodes,
  fetchIndividualOfferCode,
} from "../../../../Redux/Slices/contentManagementSlice";

const EditOfferCode = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [credits, setCredits] = useState("");
  const [codes, setCodes] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState("");
  const [description, setDescription] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const handleValidation = () => {
    let validationErrors = {};

    const creditsErrors = validateInput("offerCredits", credits);
    if (creditsErrors.credits) {
      validationErrors.credits = creditsErrors.credits;
    }

    const codesErrors = validateInput("offerCodes", codes);
    if (codesErrors.codes) {
      validationErrors.codes = codesErrors.codes;
    }

    const startDateErrors = validateInput("offerStartDate", startDate);
    if (startDateErrors.startDate) {
      validationErrors.startDate = startDateErrors.startDate;
    }

    const endDateErrors = validateInput("offerEndDate", endDate, startDate);
    if (endDateErrors.endDate) {
      validationErrors.endDate = endDateErrors.endDate;
    }

    // const notesErrors = validateInput("offerNotes", description);
    // if (notesErrors.offerNotes) {
    //   validationErrors.offerNotes = notesErrors.offerNotes;
    // }

    setErrors(validationErrors);
    return validationErrors;
  };

  const handleFromDate = (date) => {
    setStartDate(date ? new Date(date) : null)
  };
  const handleToDate = (date) => {
    setEndDate(date);
  };

  const formatDateToLocal = (dateString) => {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const validationErrors = handleValidation();
    if (Object.keys(validationErrors).length === 0) {
      // Handle form submission logic here
      const data = {
        offer_code: codes,
        number_of_credits_available: credits,
        start_date: formatDateToLocal(startDate),
        end_date: formatDateToLocal(endDate),
        notes: description,
      };
      console.log(data);
      const editOfferCB = (value) => {
        setIsSuccess(true);
      };
      dispatch(
        editOfferCodes({
          id,
          data: data,
          callBack: editOfferCB,
        })
      );
    }
  };

  const existingDetailsCB = (value) => {
    console.log(value);
    setCredits(value.result.number_of_credits_available);
    setCodes(value.result.offer_code);
    setDescription(value.result.notes);
    setStartDate(value.result.start_date);
    setEndDate(value.result.end_date);
  };

  useEffect(() => {
    dispatch(
      fetchIndividualOfferCode({
        data: {
          id,
        },
        callBack: existingDetailsCB,
      })
    );
  }, []);

  return (
    <MainLayout pageName={"Content Management"}>
      {/* SuccessCard - Conditionally render */}
      {isSuccess && (
        <SuccessCard
          title="Offer Code Edited Successfully"
          subTitle="Offer Code Details Edited Successfully."
          onClose={() => setIsSuccess(false)} // Close the SuccessCard
          onGoBack={() => navigate(-1)} // Navigate back
        />
      )}
      <div className="goBackDiv" onClick={() => navigate(-1)}>
        <img src={assets.Icons.leftArrow} alt="backIcon" />
        <p>Back to Offer Codes</p>
      </div>
      <form className="AddOfferCodeContainer" onSubmit={handleSubmit}>
        {/* Header */}
        <div className="AddOfferCodeContainerHeader">
          <h2>Edit Offer Code</h2>
        </div>
        <hr style={{ border: "1px solid #E6E6E6" }} />
        <div
          className="AddOfferCodeInputContainer"
          style={{ marginTop: "20px" }}
        >
          <p>No.of Credits Avail</p>
          <div className="AddOfferCodeInputBoxContainer">
            <InputBox
              inputStyle={{
                boxShadow: "none",
                border: "1px solid #B2BEC3",
                padding: "1px 1vh 1px 2vh",
                height: "6.5vh",
                width: "32.3vw",
                color: "black",
              }}
              type="number"
              name="credits"
              value={credits}
              onChange={(e) => setCredits(e.target.value)}
            />
            {errors.credits && <ErrorMessage message={errors.credits} />}
          </div>
        </div>
        <div className="AddOfferCodeInputBoxBody">
          <div className="AddOfferCodeInputContainer">
            <p>Valid from</p>
            <div className="AddOfferCodeInputBoxContainer">
              <DatePicker
                placeholderText="DD/MM/YYYY"
                format="dd/MM/yyyy"
                selected={startDate}
                minDate={new Date()}
                onChange={handleFromDate}
                border={true}
                image={false}
                width="31.3vw"
                height="6.5vh"
                radius="6px"
              />
              {errors.startDate && <ErrorMessage message={errors.startDate} />}
            </div>
          </div>
          <div className="AddOfferCodeInputContainer">
            <p>Valid Till</p>
            <div className="AddOfferCodeInputBoxContainer">
              <DatePicker
                placeholderText="DD/MM/YYYY"
                format="dd/MM/yyyy"
                selected={endDate}
                onChange={handleToDate}
                minDate={startDate}
                border={true}
                image={false}
                width="31.3vw"
                height="6.5vh"
                radius="6px"
              />
              {errors.endDate && <ErrorMessage message={errors.endDate} />}
            </div>
          </div>
        </div>
        <div className="AddOfferCodeInputContainer">
          <p>No.of Codes</p>
          <div className="AddOfferCodeInputBoxContainer">
            <InputBox
              inputStyle={{
                boxShadow: "none",
                border: "1px solid #B2BEC3",
                padding: "1px 1vh 1px 2vh",
                height: "6.5vh",
                width: "32.3vw",
                color: "black",
              }}
              name="codes"
              value={codes}
              onChange={(e) => setCodes(e.target.value)}
            />
            {errors.codes && <ErrorMessage message={errors.codes} />}
          </div>
        </div>
        <div className="AddOfferCodeTextContainer">
          <p>Notes</p>
          <div className="AddOfferCodeInputBoxContainer">
            <textarea
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
                setErrors({
                  ...errors,
                  offerNotes: "",
                });
              }}
              rows="5"
              placeholder="Enter here"
              className="textAreaInput"
            />
            {errors.offerNotes && <ErrorMessage message={errors.offerNotes} />}
          </div>
        </div>
        <div className="addOfferCodeButtons">
          <div className="addOfferCodeButtonContainer">
            <Button
              buttonStyle={{ height: "2vh", backgroundColor: "#FFFFFF" }}
              titleStlye={{ color: "#888888" }}
              title="Cancel"
              onClick={() => navigate(-1)}
            />
          </div>
          <div className="addOfferCodeButtonContainer">
            <Button
              forForm={true}
              buttonStyle={{ height: "2vh" }}
              title="Save"
            />
          </div>
        </div>
      </form>
    </MainLayout>
  );
};

export default EditOfferCode;
